module.exports = __webpack_public_path__ + "static/img/paiduitongzhi.993ee02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/paiduitongzhi.png
// module id = deMC
// module chunks = 24